import { apiClient } from './api';
import type { WithdrawalRequest, CreateWithdrawalRequest } from '../types/withdrawal';

export interface ApproveWithdrawalRequest {
  adminId: string;
}

export interface RejectWithdrawalRequest {
  adminId: string;
  reason: string;
}

export interface CompleteWithdrawalRequest {
  receiptUrl: string;
  taxDeduction?: number;
}

export const withdrawalService = {
  // Request withdrawal
  requestWithdrawal: async (data: CreateWithdrawalRequest): Promise<WithdrawalRequest> => {
    const response = await apiClient.post<WithdrawalRequest>('/withdrawals', data);
    return response.data as WithdrawalRequest;
  },

  // Get withdrawal request by ID
  getWithdrawalRequest: async (id: string): Promise<WithdrawalRequest> => {
    const response = await apiClient.get<WithdrawalRequest>(`/withdrawals/${id}`);
    return response.data as WithdrawalRequest;
  },

  // Get user withdrawals
  getUserWithdrawals: async (userId: string, status?: string): Promise<WithdrawalRequest[]> => {
    const params = status ? `?status=${status}` : '';
    const response = await apiClient.get<WithdrawalRequest[]>(`/withdrawals/user/${userId}${params}`);
    return response.data as WithdrawalRequest[];
  },

  // Get my withdrawals (current user) - uses user ID from auth context
  getMyWithdrawals: async (userId: string, status?: string): Promise<WithdrawalRequest[]> => {
    const params = status ? `?status=${status}` : '';
    const response = await apiClient.get<WithdrawalRequest[]>(`/withdrawals/user/${userId}${params}`);
    return response.data as WithdrawalRequest[];
  },

  // Get pending withdrawals (admin endpoint)
  getPendingWithdrawals: async (): Promise<WithdrawalRequest[]> => {
    const response = await apiClient.get<WithdrawalRequest[]>('/withdrawals/pending');
    return response.data as WithdrawalRequest[];
  },

  // Approve withdrawal (admin endpoint)
  approveWithdrawal: async (id: string, adminId: string): Promise<WithdrawalRequest> => {
    const response = await apiClient.post<WithdrawalRequest>(`/withdrawals/${id}/approve`, { admin_id: adminId });
    return response.data as WithdrawalRequest;
  },

  // Reject withdrawal (admin endpoint)
  rejectWithdrawal: async (id: string, adminId: string, reason: string): Promise<WithdrawalRequest> => {
    const response = await apiClient.post<WithdrawalRequest>(`/withdrawals/${id}/reject`, { admin_id: adminId, reason });
    return response.data as WithdrawalRequest;
  },

  // Complete withdrawal (admin endpoint)
  completeWithdrawal: async (id: string, receiptUrl: string, taxDeduction?: number): Promise<WithdrawalRequest> => {
    const response = await apiClient.post<WithdrawalRequest>(`/withdrawals/${id}/complete`, { receipt_url: receiptUrl, tax_deduction: taxDeduction });
    return response.data as WithdrawalRequest;
  },
};
